import { render, staticRenderFns } from "./PublicityHistory.vue?vue&type=template&id=4fb74ed4&scoped=true&"
import script from "./PublicityHistory.vue?vue&type=script&lang=js&"
export * from "./PublicityHistory.vue?vue&type=script&lang=js&"
import style0 from "./PublicityHistory.vue?vue&type=style&index=0&id=4fb74ed4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb74ed4",
  null
  
)

export default component.exports